import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReportsAbstractService} from './reports-abstract.service';
import {Observable} from 'rxjs';

@Injectable()
export class RetentionReportService extends ReportsAbstractService {
  public reportRoute: string = 'retention_report'

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  getSummary(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/summary/", params);
  }

  getOrderOptionsBreakdown(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/order_options_breakdown/", params);
  }

  getHoldStatusCancellationsBreakdown(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/hold_status_cancellations/", params);
  }

  getSubscriptionCancellationsBreakdown(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/subscription_cancellations/", params);
  }
  getReturnRequestsBreakdown(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/return_requests/", params);
  }

  downloadFile(queryParams, elem) {
    queryParams['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    this.getDownloadReportData(queryParams)
      .subscribe(_ => {
        elem.loading = false
      }, error => {
        elem.loading = false
      })
  }
}
